/* Auto-generated from 1. ST population as per Socio-economic assessment.xlsx */
const ST_SOCIO_ECON = {
  "state": {
    "st_households": 243840,
    "st_population": 837281,
    "st_male": 420277,
    "st_female": 416808,
    "st_third_gender": 196
  },
  "districts": {
    "Salem": {
      "st_households": 33801,
      "st_population": 112916,
      "st_pct": 0.1348603396,
      "st_male": 57137,
      "st_female": 55769,
      "st_third_gender": 10
    },
    "Tiruvannamalai": {
      "st_households": 27418,
      "st_population": 93613,
      "st_pct": 0.1118059528,
      "st_male": 47163,
      "st_female": 46418,
      "st_third_gender": 32
    },
    "Dharmapuri": {
      "st_households": 19820,
      "st_population": 69435,
      "st_pct": 0.08292914804,
      "st_male": 35392,
      "st_female": 34013,
      "st_third_gender": 30
    },
    "Namakkal": {
      "st_households": 18259,
      "st_population": 60087,
      "st_pct": 0.07176443751,
      "st_male": 30780,
      "st_female": 29303,
      "st_third_gender": 4
    },
    "Kallakurichi": {
      "st_households": 15248,
      "st_population": 58450,
      "st_pct": 0.06980929939,
      "st_male": 29741,
      "st_female": 28707,
      "st_third_gender": 2
    },
    "Tiruvallur": {
      "st_households": 13640,
      "st_population": 43802,
      "st_pct": 0.05231457539,
      "st_male": 21639,
      "st_female": 22145,
      "st_third_gender": 18
    },
    "Nilgiris": {
      "st_households": 9237,
      "st_population": 29641,
      "st_pct": 0.03540149603,
      "st_male": 14092,
      "st_female": 15548,
      "st_third_gender": 1
    },
    "Villupuram": {
      "st_households": 9083,
      "st_population": 29618,
      "st_pct": 0.03537402616,
      "st_male": 14648,
      "st_female": 14959,
      "st_third_gender": 11
    },
    "Chengalpattu": {
      "st_households": 8306,
      "st_population": 27295,
      "st_pct": 0.03259956932,
      "st_male": 13567,
      "st_female": 13710,
      "st_third_gender": 18
    },
    "Coimbatore": {
      "st_households": 8400,
      "st_population": 25737,
      "st_pct": 0.03073878423,
      "st_male": 12631,
      "st_female": 13101,
      "st_third_gender": 5
    },
    "Vellore": {
      "st_households": 7021,
      "st_population": 24584,
      "st_pct": 0.02936170772,
      "st_male": 12189,
      "st_female": 12380,
      "st_third_gender": 15
    },
    "Krishnagiri": {
      "st_households": 6162,
      "st_population": 22914,
      "st_pct": 0.02736715631,
      "st_male": 11617,
      "st_female": 11285,
      "st_third_gender": 12
    },
    "Thiruchirapalli": {
      "st_households": 5296,
      "st_population": 18808,
      "st_pct": 0.02246318739,
      "st_male": 9607,
      "st_female": 9199,
      "st_third_gender": 2
    },
    "Erode": {
      "st_households": 5727,
      "st_population": 18418,
      "st_pct": 0.02199739395,
      "st_male": 9129,
      "st_female": 9288,
      "st_third_gender": 1
    },
    "Cuddalore": {
      "st_households": 4596,
      "st_population": 16133,
      "st_pct": 0.0192683221,
      "st_male": 7973,
      "st_female": 8156,
      "st_third_gender": 4
    },
    "Kancheepuram": {
      "st_households": 4704,
      "st_population": 15524,
      "st_pct": 0.01854096773,
      "st_male": 7658,
      "st_female": 7860,
      "st_third_gender": 6
    },
    "Ariyalur": {
      "st_households": 3331,
      "st_population": 11894,
      "st_pct": 0.01420550568,
      "st_male": 5926,
      "st_female": 5967,
      "st_third_gender": 1
    },
    "Madurai": {
      "st_households": 2963,
      "st_population": 10565,
      "st_pct": 0.01261822494,
      "st_male": 5248,
      "st_female": 5317,
      "st_third_gender": 0
    },
    "Dindigul": {
      "st_households": 2836,
      "st_population": 9540,
      "st_pct": 0.01139402423,
      "st_male": 4792,
      "st_female": 4747,
      "st_third_gender": 1
    },
    "Kanyakumari": {
      "st_households": 2146,
      "st_population": 7052,
      "st_pct": 0.008422500929,
      "st_male": 3472,
      "st_female": 3579,
      "st_third_gender": 1
    },
    "Tiruppur": {
      "st_households": 1877,
      "st_population": 6410,
      "st_pct": 0.00765573326,
      "st_male": 3116,
      "st_female": 3292,
      "st_third_gender": 2
    },
    "Tirunelveli": {
      "st_households": 1704,
      "st_population": 6007,
      "st_pct": 0.007174413369,
      "st_male": 2969,
      "st_female": 3037,
      "st_third_gender": 1
    },
    "Thanjavur": {
      "st_households": 1595,
      "st_population": 5995,
      "st_pct": 0.007160081263,
      "st_male": 2998,
      "st_female": 2996,
      "st_third_gender": 1
    },
    "Tenkasi": {
      "st_households": 1571,
      "st_population": 5399,
      "st_pct": 0.006448253334,
      "st_male": 2628,
      "st_female": 2770,
      "st_third_gender": 1
    },
    "Perambalur": {
      "st_households": 1460,
      "st_population": 4933,
      "st_pct": 0.005891689887,
      "st_male": 2479,
      "st_female": 2452,
      "st_third_gender": 2
    },
    "Tiruvarur": {
      "st_households": 1382,
      "st_population": 4900,
      "st_pct": 0.005852276595,
      "st_male": 2423,
      "st_female": 2477,
      "st_third_gender": 0
    },
    "Sivagangai": {
      "st_households": 1159,
      "st_population": 3924,
      "st_pct": 0.004686598645,
      "st_male": 1931,
      "st_female": 1993,
      "st_third_gender": 0
    },
    "Ramanathapuram": {
      "st_households": 906,
      "st_population": 3431,
      "st_pct": 0.004097787959,
      "st_male": 1712,
      "st_female": 1719,
      "st_third_gender": 0
    },
    "Pudukkottai": {
      "st_households": 968,
      "st_population": 3358,
      "st_pct": 0.004010600981,
      "st_male": 1661,
      "st_female": 1697,
      "st_third_gender": 0
    },
    "Mayiladuthurai": {
      "st_households": 729,
      "st_population": 2654,
      "st_pct": 0.003169784099,
      "st_male": 1311,
      "st_female": 1343,
      "st_third_gender": 0
    },
    "Theni": {
      "st_households": 799,
      "st_population": 2619,
      "st_pct": 0.003127982123,
      "st_male": 1309,
      "st_female": 1308,
      "st_third_gender": 2
    },
    "Virudhunagar": {
      "st_households": 665,
      "st_population": 2422,
      "st_pct": 0.002892696717,
      "st_male": 1228,
      "st_female": 1193,
      "st_third_gender": 1
    },
    "Nagapattinam": {
      "st_households": 520,
      "st_population": 1867,
      "st_pct": 0.002229836817,
      "st_male": 907,
      "st_female": 960,
      "st_third_gender": 0
    },
    "Chennai": {
      "st_households": 546,
      "st_population": 1809,
      "st_pct": 0.002160564972,
      "st_male": 884,
      "st_female": 925,
      "st_third_gender": 0
    },
    "Karur": {
      "st_households": 373,
      "st_population": 1316,
      "st_pct": 0.001571754286,
      "st_male": 638,
      "st_female": 677,
      "st_third_gender": 1
    },
    "Thoothukudi": {
      "st_households": 1355,
      "st_population": 4954,
      "st_pct": 0.005916771072,
      "st_male": 2439,
      "st_female": 2515,
      "st_third_gender": 0
    },
    "Tirupattur": {
      "st_households": 15065,
      "st_population": 58578,
      "st_pct": 0.06996217518,
      "st_male": 29938,
      "st_female": 28631,
      "st_third_gender": 9
    },
    "Ranipettai": {
      "st_households": 3172,
      "st_population": 10679,
      "st_pct": 0.01275437995,
      "st_male": 5305,
      "st_female": 5372,
      "st_third_gender": 2
    }
  }
};
export default ST_SOCIO_ECON;
